import { useQuery } from '@tanstack/react-query';
import { getBreakoutWatch } from '../lib/apiClient';

// The logger runs once an hour; no need to poll faster.
const STALE_TIME_MS = 5 * 60_000;

/** Forward paper test of Breakout Watch. Hypothetical only. */
export function useBreakoutWatch() {
  return useQuery({
    queryKey: ['breakout-watch'],
    queryFn: getBreakoutWatch,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  });
}
